import {mediaServiceIsAuthenticated} from '@netx/core-share-media-service/enablers';
import {currentUserMeetsUserLevel, UserLevel} from '@netx/core-user-next/utils';
// import {permissionsEnabled} from '@netx/core-permissions-next/enablers';
import {type IAsset} from '../schema';

export const canPublishAsset = (asset?: IAsset, mediaServiceName = '') => {
	if (!asset?.fileFormatFamily.includes('video')) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return mediaServiceIsAuthenticated(mediaServiceName);
}
